import { orderStatusesApi, type OrderStatus } from '@/lib/api/services/orderStatuses';

export const ORDER_STATUS_SLUGS = [
  'pending',
  'order_accepted',
  'processing',
  'rider_pending',
  'rider_assigned',
  'delivered',
  'fulfilled',
  'cancelled',
] as const;

export type OrderStatusSlug = (typeof ORDER_STATUS_SLUGS)[number];

export const DEFAULT_ORDER_STATUSES: OrderStatus[] = [
  { slug: 'pending', name: 'Pending', color: '#f59e0b' },
  { slug: 'order_accepted', name: 'Order Accepted', color: '#3b82f6' },
  { slug: 'processing', name: 'Processing', color: '#06b6d4' },
  { slug: 'shipped', name: 'Assign Rider', color: '#0891b2' },
  { slug: 'rider_pending', name: 'Awaiting Rider', color: '#f59e0b' },
  { slug: 'rider_assigned', name: 'Rider Assigned', color: '#4f46e5' },
  { slug: 'delivered', name: 'Delivered', color: '#10b981' },
  { slug: 'fulfilled', name: 'Fulfilled', color: '#10b981' },
  { slug: 'cancelled', name: 'Cancelled', color: '#ef4444' },
  { slug: 'refunded', name: 'Refunded', color: '#6b7280' },
] as any[];

export function mergeOrderStatuses(custom: OrderStatus[]): OrderStatus[] {
  const list = Array.isArray(custom) ? custom : [];
  const customSlugs = new Set(list.map((s) => s.slug));
  return [
    ...list,
    ...DEFAULT_ORDER_STATUSES.filter((d) => !customSlugs.has(d.slug)),
  ];
}

export async function loadOrderStatuses(): Promise<OrderStatus[]> {
  try {
    const data = await orderStatusesApi.list();
    return mergeOrderStatuses(data);
  } catch {
    return DEFAULT_ORDER_STATUSES;
  }
}
